import {Component} from '@angular/core';
import {Breadcrumb} from 'primeng/breadcrumb';
import{MenuItem} from 'primeng/api';
import {BreadcrumbService} from '../../breadcrumb-service/breadcrumb-service';


@Component({
  templateUrl: './breadcrumb.html',
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [Breadcrumb],
})

export class BreadcrumbComponent{
  items: MenuItem[] | undefined;

  home: MenuItem = {
    icon: 'pi pi-home',
    label: 'Home',
    routerLink: '/'
  };

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbService.breadcrumbs$.subscribe(breadcrumbs => {
      this.items = breadcrumbs;
    });


  }
}
